export enum SortTypeEnum {
  TASKS = 1,
  REPORTS = 2,
  BOTH = 3,
}

export enum SortFieldEnum {
  PROPERTY = "property",
  INSIDE = "inside",
  PRIORITY = "priority",
  DEADLINE_AT = "deadline_at",
  TIME_SENSITIVE = "time_sensitive",
  QUANTITY = "quantity",
  BLOCKING = "blocking",
  PRODUCT = "product",
  PRODUCT_COSTS = "product_costs",
}

export enum SortCategoryEnum {
  CLEANING = 1,
  LEGIONELLA_RINSE = 2,
}

export enum SortComponentEnum {
  TIME_ENTRY = "time_entry",
  PRODUCT = "product",
  ATTACHMENT = "attachment",
  SUBTASK = "subtask",
  NOTE = "note",
}

export enum SortFollowFieldEnum {
  PROPERTY = "property",
  RESERVATION = "reservation",
  STATUS = "status",
  DEADLINE_AT = "deadline_at",
}

export const SORT_FOLLOW_FIELD_VALUES = [
  SortFollowFieldEnum.PROPERTY,
  SortFollowFieldEnum.RESERVATION,
  SortFollowFieldEnum.STATUS,
  SortFollowFieldEnum.DEADLINE_AT,
] as const;

export const SORT_DEFAULT_SUB_TASK_FOLLOW_FIELDS: SortFollowFieldEnum[] = [
  SortFollowFieldEnum.PROPERTY,
  SortFollowFieldEnum.RESERVATION,
  SortFollowFieldEnum.STATUS,
];
